import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Typography } from "@material-ui/core";
import LoginLayout from "./LoginLayout";
import { useAuthProvider } from "react-admin";

const LoggedOut = () => {
  const auth = useAuthProvider();
  const history = useHistory();
  const [loggedOut, setLoggedOut] = useState<boolean>(false);

  useEffect(() => {
    if (!auth?.getIdentity) {
      setLoggedOut(true);
      return;
    }

    auth
      .getIdentity()
      .then((value) => {
        if (!value?.id) {
          // Really logged out
          setLoggedOut(true);
          return;
        }

        history.replace({ pathname: "/", search: "" });
      })
      .catch(() => {
        // Really logged out
        setLoggedOut(true);
      });
  }, [auth, history]);

  return (
    <LoginLayout>
      {loggedOut ? (
        <>
          <Typography variant="body1">You are now logged out.</Typography>
          <Typography variant="body1">
            Click <Link to="/">here</Link> to return to the application.
          </Typography>
        </>
      ) : null}
    </LoginLayout>
  );
};

export default LoggedOut;
